/* @flow */
import React, {PropTypes} from 'react';
import SalaryInfo from '../../settings/salary-info/salary-info';
import ChangePassword from '../../settings/change-password/change-password';
import OwnEmployment from '../../settings/own-employment/own-employment';
import PersonalInfo from '../../settings/personal-info/personal-info';
import Translate from 'react-translate-component';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

export class SettingsTabWrapper extends React.Component {

  static propTypes = {
    closeSettingsModal: PropTypes.func.isRequired
  };

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  render () {
    return (
      <div className='settings-tab-wrapper'>
        <Tabs defaultActiveKey={1} animation={false} id='settings-tap-wrapper'>
          <Tab eventKey={1} title={proxyCounterpart('SALARY_INFO')}>
            <SalaryInfo />
          </Tab>
          <Tab eventKey={2} title={proxyCounterpart('CHANGE_PASSWORD')}>
            <ChangePassword />
          </Tab>
          <Tab eventKey={3} title={proxyCounterpart('OWN_EMPLOYMENT')}>
            <OwnEmployment />
          </Tab>
          <Tab eventKey={4} title={proxyCounterpart('PERSONAL_INFO')}>
            <PersonalInfo />
          </Tab>
        </Tabs>
        <a className='btn outlined blue' onClick={this.props.closeSettingsModal}>
          <span><Translate content='CLOSE'/></span>
        </a>
      </div>
    );
  }
}

export default SettingsTabWrapper;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/settings/settings-tab-wrapper.js
 **/